import type { AiCapabilityPage } from "../schema.js";
import { ALL_ROLES, LIVE } from "./_shared.js";

/**
 * `HELP-FROM-REGISTRY` (@UC0208) — câu "cách dùng" dịch ra TRANG của Sổ + nút "Thử ngay". Tier `read`.
 * Executor `registryRead.help` — đọc CHÍNH Sổ này (help.title/tryNow của các trang mà vai người hỏi được dùng), không mô tả tính
 * năng ngoài Sổ (ADR cam kết 7: đọc Sổ là biết AI làm gì). Nút "Thử ngay" là chip gửi câu `help.tryNow` — bấm = 0 LLM (@UC0174).
 */
// Tên hằng cố ý KHÔNG kết thúc bằng `_REGISTRY`: bộ quét G14k coi mọi `export const *_REGISTRY` là một Sổ.
export const REGISTRY_HELP_PAGE = {
  id: "HELP-FROM-REGISTRY",
  uc: "@UC0208",
  tier: "read",
  status: LIVE,
  roles: ALL_ROLES,
  flags: [],
  /*
   * 🔴 **KHÔNG CÒN Ô `chuDe`** (review #874 HIGH-3, gỡ 19/09) — và lý do là lý do TIỀN LỆ `@UC0213` đã dùng một task trước.
   *
   * Ô đó là **text tự do, tuỳ chọn**, hứa "lọc theo chủ đề". Đo được: binding là `read(_ctx)` — **không đọc ô**; 0 ca test
   * nhắc tới nó. Tức nó trả **chi phí PII THẬT** (câu người dùng gõ vào ô vào thẳng `rawPrompt`, bảng `ai_audit_log`
   * **append-only**, `purgeUserPii` đi theo `userId` nên **không có đường xoá**) để đổi lấy **0 chức năng**.
   *
   * Vá bằng cách "thực hiện bộ lọc" thì đắt hơn và vẫn phải bịa một phân loại chủ đề mà Sổ KHÔNG có. Gỡ ô là rẻ nhất,
   * an toàn nhất, và trang vẫn làm đúng việc của nó: 0 ô ⇒ hỏi là trả lời ngay, không lượt hỏi lại nào.
   */
  slots: [],
  llm: {
    description: "Người dùng hỏi trợ lý làm được gì hoặc cách làm một việc; trả lời bằng danh sách trang trong Sổ kèm câu gõ thử.",
    examples: [
      "bạn làm được gì?",
      "ban lam duoc gi",
      "cách mở đợt thu thế nào?",
      "cach mo dot thu",
      "hướng dẫn dùng trợ lý",
      "huong dan",
      "help",
      "làm sao để ghi chi",
      "trợ lý này dùng để làm gì",
      "menu",
      "tôi có thể hỏi gì",
      // ——— 0105: thêm cho đủ 40 ———
      "lam sao de ghi chi",
      "tro ly nay dung de lam gi",
      "toi co the hoi gi",
      "bạn giúp được những việc gì?",
      "ban giup duoc nhung viec gi",
      "trợ lý làm được những gì",
      "tro ly lam duoc nhung gi",
      "hướng dẫn cho mình dùng app với",
      "huong dan cho minh dung app voi",
      "mình mới dùng, chỉ mình cái",
      "minh moi dung chi minh cai",
      "chỉ cho tôi cách dùng",
      "chi cho toi cach dung",
      "có thể nhắn gì với bạn",
      "co the nhan gi voi ban",
      "liệt kê các việc làm được",
      "liet ke cac viec lam duoc",
      "danh sách chức năng",
      "danh sach chuc nang",
      "tôi nên gõ gì bây giờ",
      "toi nen go gi bay gio",
      "bạn biết làm gì",
      "ban biet lam gi",
      "chỉ mình vài câu mẫu",
      "chi minh vai cau mau",
      "app này làm được gì",
      "app nay lam duoc gi",
      "trợ giúp dùng trợ lý",
      "tro giup dung tro ly",
      "chỉ mình cách nhờ trợ lý làm việc",
      "chi minh cach nho tro ly lam viec",
      "giúp mình với, mình chưa biết bắt đầu từ đâu",
      "giup minh voi minh chua biet bat dau tu dau",
    ],
    // AI-INTERP M12 (QĐ I12): câu THỬ — KHÔNG vào prompt/BM25; viết đời thường, không chép ví dụ (validator HELD_OUT_IS_EXAMPLE).
    heldOutExamples: [
      "app nay xai sao vay em",
      "trợ lý biết làm mấy việc gì z",
      "chỉ chị cách xài cái chat này với",
      "co nhung lenh gi go dc ko",
      "mới tải app, giờ bắt đầu từ đâu ạ",
      "ủa bot này làm đc gì á",
    ],
    /*
     * 🔴 US-AIV2-0105 — `"giúp"` MỘT CHỮ chuyển sang đây. Đo 24/09: model trả `unknown` (conf 0,05),
     * và đó là **phản ứng ĐÚNG** — một chữ "giúp" không có tân ngữ, nó có thể là "giúp tôi mở đợt thu",
     * "giúp tôi xoá tài khoản", hay đúng là hỏi trợ lý làm được gì. Ép nó thành một đáp án là dạy model
     * đoán thay người dùng (`@UC0171`). Câu `"help"` / `"menu"` thì KHÁC: chúng là tên gọi của chính
     * màn trợ giúp, không phải động từ thiếu tân ngữ.
     */
    clarifyExamples: ["giúp"],
  },
  executor: "registryRead.help",
  /** `@UC0216` — cửa mobile trang này chịu trách nhiệm: trang đọc chính Sổ — không có cửa HTTP nào của mobile. */
  endpoints: [],
  facts: ["danhSachViec"],
  templates: {
    /*
     * 🔴 Câu cũ hứa *"Bấm “Thử ngay” **dưới mỗi việc**"* — đo được là **SAI**: chip của lượt đến từ `next` của kết quả
     * (Sổ — 0005; rỗng) qua `runPageChips`, không từ danh sách việc; thực tế render **1 chip**, và nó là một trang KHÔNG có trong
     * danh sách. Trang trả lời *"trợ lý làm được gì"* mà mô tả sai chính thao tác của mình là hỏng đúng chỗ nó tồn tại.
     * Câu mới chỉ hứa thứ CÓ THẬT: gõ chữ thì người phiên dịch định tuyến tới trang.
     */
    // US-AIV2-0109 S07 (@UC0242): danh sách xuống dòng (`• việc` mỗi dòng).
    // 🔴 US-AIV2-0112 lô Sổ 4 (@UC0240): câu dẫn "Mình làm được những việc này…" RỜI template, đi cùng danh sách trong fact (binding
    // `registryRead.help`) — ở đây nó đứng trên cả câu NGƯỜI MỚI (0 nhóm: hai đường vào + 3 bước), hứa một danh sách không có.
    reply: "{danhSachViec}\nNhắn tên việc bạn muốn làm để bắt đầu.",
  },
  // US-AIV2-tourguide-0005 (@UC0364): danh sách việc · câu người mới (0 nhóm — nút «Tạo nhóm» là của thẻ SETUP-NO-GROUP) — không mời trang nào.
  journey: { outcomes: { list: { next: [] }, newcomer: { next: [] } } },
  help: { title: "Trợ lý làm được gì", tryNow: "bạn làm được gì?" },
} satisfies AiCapabilityPage;
